// extracted by mini-css-extract-plugin
export default {"page":"shared_page__DI3vZ","centered":"shared_centered__uT-VW","emptyState":"shared_emptyState__qEvvZ"};